export default "__VITE_ASSET__DoyJ4JN7__"